// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/analytics';
import model_2 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/apiKeys';
import model_3 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/automation';
import model_4 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/billing';
import model_5 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/bookingPages';
import model_6 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/call';
import model_7 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/customer';
import model_8 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/date';
import model_9 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/emailCenter';
import model_10 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/extraFields';
import model_11 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/help';
import model_12 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/image';
import model_13 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/journey';
import model_14 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/lead';
import model_15 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/leadsAnalytics';
import model_16 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/leadSource';
import model_17 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/leadState';
import model_18 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/leadTask';
import model_19 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/location';
import model_20 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/periodSelector';
import model_21 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/preferences';
import model_22 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/productGroup';
import model_23 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/promotion';
import model_24 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/role';
import model_25 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/salesInfluencer';
import model_26 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/serviceRequest';
import model_27 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/tagStatistics';
import model_28 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/taskAutomation';
import model_29 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/ticketDrawer';
import model_30 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/user';

export const models = {
model_1: { namespace: 'analytics', model: model_1 },
model_2: { namespace: 'apiKeys', model: model_2 },
model_3: { namespace: 'automation', model: model_3 },
model_4: { namespace: 'billing', model: model_4 },
model_5: { namespace: 'bookingPages', model: model_5 },
model_6: { namespace: 'call', model: model_6 },
model_7: { namespace: 'customer', model: model_7 },
model_8: { namespace: 'date', model: model_8 },
model_9: { namespace: 'emailCenter', model: model_9 },
model_10: { namespace: 'extraFields', model: model_10 },
model_11: { namespace: 'help', model: model_11 },
model_12: { namespace: 'image', model: model_12 },
model_13: { namespace: 'journey', model: model_13 },
model_14: { namespace: 'lead', model: model_14 },
model_15: { namespace: 'leadsAnalytics', model: model_15 },
model_16: { namespace: 'leadSource', model: model_16 },
model_17: { namespace: 'leadState', model: model_17 },
model_18: { namespace: 'leadTask', model: model_18 },
model_19: { namespace: 'location', model: model_19 },
model_20: { namespace: 'periodSelector', model: model_20 },
model_21: { namespace: 'preferences', model: model_21 },
model_22: { namespace: 'productGroup', model: model_22 },
model_23: { namespace: 'promotion', model: model_23 },
model_24: { namespace: 'role', model: model_24 },
model_25: { namespace: 'salesInfluencer', model: model_25 },
model_26: { namespace: 'serviceRequest', model: model_26 },
model_27: { namespace: 'tagStatistics', model: model_27 },
model_28: { namespace: 'taskAutomation', model: model_28 },
model_29: { namespace: 'ticketDrawer', model: model_29 },
model_30: { namespace: 'user', model: model_30 },
} as const
